import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import RibbonTagComponent from '../../../../shared/RibbonTagComponent/RibbonTagComponent.jsx';

export const TileImage = ({
  thumbnail,
  ribbonTagName,
  ribbonTagColor,
  tileStatus,
}) => (
  <ImageContainer>
    <Image src={thumbnail} />
    {ribbonTagName && (
      <RibbonTagComponent
        ribbonTagName={ribbonTagName}
        ribbonTagColor={ribbonTagColor}
        height="28"
      />
    )}
    {tileStatus === 'archive' && (
      <HiddenTag>
        <i className="fa-regular fa-eye-slash"></i> Hidden
      </HiddenTag>
    )}
  </ImageContainer>
);

const HiddenTag = styled.div`
  font-size: 12px;
  position: absolute;
  top: 10px;
  left: 5px;
  border-radius: 10px;
  border: 1px #fff solid;
  background: #e8e8e8e3;
  padding: 2px 5px;
  color: #000;
`;

const ImageContainer = styled.div`
  position: relative;
  height: 102px;
`;

const Image = styled.img`
  height: 100%;
  width: 100%;
  object-fit: cover;
  border-bottom: 1px solid ${themeGet('colors.black.10')};
  border-radius: 8px 8px 0 0;
`;
